<template>
  <span @click="sortClicked" class="sort-control cursor-pointer">
    <slot></slot>
    <icon v-if="selected && direction === ASCENDING" name="fa-caret-up" />
    <icon v-if="selected && direction === DESCENDING" name="fa-caret-down" />
  </span>
</template>
<script>
import { direction as sortDirection } from "@/util/sort";

export default {
  props: ["selected", "field"],
  emits: ["sort-click"],
  data: function() {
    return {
      ASCENDING: sortDirection.ASCENDING,
      DESCENDING: sortDirection.DESCENDING,
      direction: sortDirection.ASCENDING,
    };
  },
  methods: {
    sortClicked: function() {
      this.direction =
        this.direction === sortDirection.ASCENDING
          ? sortDirection.DESCENDING
          : sortDirection.ASCENDING;

      const args = {
        field: this.field,
        direction: this.direction,
      };

      this.logDebug("Sort order changed.", args);
      this.$emit("sort-click", args);
    },
  },
};
</script>
